import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { RequirementStatus } from "@wingspanhq/payments/dist/interfaces/requirement";

/**
 * A requirement reaches PendingReview only through the payer-review flow: by
 * the definition's strategy, or because the data source itself asked for a
 * decision, as a coverage imported with warnings does even under NeverRequired.
 * The status alone is therefore the signal; gating on the strategy hid the
 * review the payer was being asked for.
 */
export const selectorIsRequirementPendingApproval = (
  requirement: IRequirementResponse
) => requirement.status === RequirementStatus.PendingReview;
